// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file sprite.proto (package protosprite, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FloatValueJson, Int32ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sprite.proto.
 */
export const file_sprite: GenFile = /*@__PURE__*/
  fileDesc("CgxzcHJpdGUucHJvdG8SC3Byb3Rvc3ByaXRlIiAKCFBvc2l0aW9uEgkKAXgYASABKAUSCQoBeRgCIAEoBSIlCgRTaXplEg0KBXdpZHRoGAEgASgFEg4KBmhlaWdodBgCIAEoBSKMAgoFRnJhbWUSDQoFaW5kZXgYASABKAUSLQoGbGF5ZXJzGAIgAygLMh0ucHJvdG9zcHJpdGUuRnJhbWUuRnJhbWVMYXllchIQCghkdXJhdGlvbhgDIAEoAhqyAQoKRnJhbWVMYXllchITCgtsYXllcl9pbmRleBgBIAEoBRIfCgRzaXplGAIgASgLMhEucHJvdG9zcHJpdGUuU2l6ZRItCg5zaGVldF9wb3NpdGlvbhgDIAEoCzIVLnByb3Rvc3ByaXRlLlBvc2l0aW9uEi4KD3Nwcml0ZV9wb3NpdGlvbhgEIAEoCzIVLnByb3Rvc3ByaXRlLlBvc2l0aW9uEg8KB3pfaW5kZXgYBSABKAUiiAEKBUxheWVyEgwKBG5hbWUYASABKAkSEAoIaXNfZ3JvdXAYAiABKAgSMQoMcGFyZW50X2luZGV4GAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLAoHb3BhY2l0eRgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5GbG9hdFZhbHVlIkEKCUFuaW1hdGlvbhIMCgRuYW1lGAEgASgJEhMKC2luZGV4X3N0YXJ0GAIgASgFEhEKCWluZGV4X2VuZBgDIAEoBSKUAQoTRW1iZWRkZWRTcHJpdGVTaGVldBI7CghlbmNvZGluZxgBIAEoDjIpLnByb3Rvc3ByaXRlLkVtYmVkZGVkU3ByaXRlU2hlZXQuRW5jb2RpbmcSDAoEZGF0YRgCIAEoDCIyCghFbmNvZGluZxIUChBFTkNPRElOR19VTktOT1dOEAASEAoMRU5DT0RJTkdfUE5HEAEiQwoTRXh0ZXJuYWxTcHJpdGVTaGVldBINCgN1cmwYAiABKAlIABITCglmaWxlX25hbWUYAyABKAlIAEIICgZzb3VyY2Ui1wIKBlNwcml0ZRIMCgRuYW1lGAEgASgJEiIKGGVtYmVkZGVkX2luX3BhcmVudF9zaGVldBgCIAEoCEgAEjoKDmVtYmVkZGVkX3NoZWV0GAMgASgLMiAucHJvdG9zcHJpdGUuRW1iZWRkZWRTcHJpdGVTaGVldEgAEjoKDmV4dGVybmFsX3NoZWV0GAQgASgLMiAucHJvdG9zcHJpdGUuRXh0ZXJuYWxTcHJpdGVTaGVldEgAEiIKBmZyYW1lcxgFIAMoCzISLnByb3Rvc3ByaXRlLkZyYW1lEiIKBmxheWVycxgGIAMoCzISLnByb3Rvc3ByaXRlLkxheWVyEioKCmFuaW1hdGlvbnMYByADKAsyFi5wcm90b3Nwcml0ZS5BbmltYXRpb24SHwoEc2l6ZRgIIAEoCzIRLnByb3Rvc3ByaXRlLlNpemVCDgoMcGl4ZWxfc291cmNlIrsBCgtTcHJpdGVTaGVldBIkCgdzcHJpdGVzGAEgAygLMhMucHJvdG9zcHJpdGUuU3ByaXRlEjoKDmVtYmVkZGVkX3NoZWV0GAIgASgLMiAucHJvdG9zcHJpdGUuRW1iZWRkZWRTcHJpdGVTaGVldEgAEjoKDmV4dGVybmFsX3NoZWV0GAMgASgLMiAucHJvdG9zcHJpdGUuRXh0ZXJuYWxTcHJpdGVTaGVldEgAQg4KDHBpeGVsX3NvdXJjZWIGcHJvdG8z", [file_google_protobuf_wrappers]);

/**
 * 2D coordinates.
 *
 * @generated from message protosprite.Position
 */
export type Position = Message<"protosprite.Position"> & {
  /**
   * @generated from field: int32 x = 1;
   */
  x: number;

  /**
   * @generated from field: int32 y = 2;
   */
  y: number;
};

/**
 * 2D coordinates.
 *
 * @generated from message protosprite.Position
 */
export type PositionJson = {
  /**
   * @generated from field: int32 x = 1;
   */
  x?: number;

  /**
   * @generated from field: int32 y = 2;
   */
  y?: number;
};

/**
 * Describes the message protosprite.Position.
 * Use `create(PositionSchema)` to create a new message.
 */
export const PositionSchema: GenMessage<Position, {jsonType: PositionJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 0);

/**
 * @generated from message protosprite.Size
 */
export type Size = Message<"protosprite.Size"> & {
  /**
   * @generated from field: int32 width = 1;
   */
  width: number;

  /**
   * @generated from field: int32 height = 2;
   */
  height: number;
};

/**
 * @generated from message protosprite.Size
 */
export type SizeJson = {
  /**
   * @generated from field: int32 width = 1;
   */
  width?: number;

  /**
   * @generated from field: int32 height = 2;
   */
  height?: number;
};

/**
 * Describes the message protosprite.Size.
 * Use `create(SizeSchema)` to create a new message.
 */
export const SizeSchema: GenMessage<Size, {jsonType: SizeJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 1);

/**
 * This message represents one frame of the sprite.
 *
 * @generated from message protosprite.Frame
 */
export type Frame = Message<"protosprite.Frame"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: repeated protosprite.Frame.FrameLayer layers = 2;
   */
  layers: Frame_FrameLayer[];

  /**
   * @generated from field: float duration = 3;
   */
  duration: number;
};

/**
 * This message represents one frame of the sprite.
 *
 * @generated from message protosprite.Frame
 */
export type FrameJson = {
  /**
   * @generated from field: int32 index = 1;
   */
  index?: number;

  /**
   * @generated from field: repeated protosprite.Frame.FrameLayer layers = 2;
   */
  layers?: Frame_FrameLayerJson[];

  /**
   * @generated from field: float duration = 3;
   */
  duration?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message protosprite.Frame.
 * Use `create(FrameSchema)` to create a new message.
 */
export const FrameSchema: GenMessage<Frame, {jsonType: FrameJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 2);

/**
 * Since frames can have multiple layers, we embed all non-empty layers here.
 *
 * @generated from message protosprite.Frame.FrameLayer
 */
export type Frame_FrameLayer = Message<"protosprite.Frame.FrameLayer"> & {
  /**
   * @generated from field: int32 layer_index = 1;
   */
  layerIndex: number;

  /**
   * @generated from field: protosprite.Size size = 2;
   */
  size?: Size;

  /**
   * @generated from field: protosprite.Position sheet_position = 3;
   */
  sheetPosition?: Position;

  /**
   * @generated from field: protosprite.Position sprite_position = 4;
   */
  spritePosition?: Position;

  /**
   * Aseprite supports the concept of z offsets for individual cels. This
   * allows a given layer to move in front of another layer.
   *
   * @generated from field: int32 z_index = 5;
   */
  zIndex: number;
};

/**
 * Since frames can have multiple layers, we embed all non-empty layers here.
 *
 * @generated from message protosprite.Frame.FrameLayer
 */
export type Frame_FrameLayerJson = {
  /**
   * @generated from field: int32 layer_index = 1;
   */
  layerIndex?: number;

  /**
   * @generated from field: protosprite.Size size = 2;
   */
  size?: SizeJson;

  /**
   * @generated from field: protosprite.Position sheet_position = 3;
   */
  sheetPosition?: PositionJson;

  /**
   * @generated from field: protosprite.Position sprite_position = 4;
   */
  spritePosition?: PositionJson;

  /**
   * Aseprite supports the concept of z offsets for individual cels. This
   * allows a given layer to move in front of another layer.
   *
   * @generated from field: int32 z_index = 5;
   */
  zIndex?: number;
};

/**
 * Describes the message protosprite.Frame.FrameLayer.
 * Use `create(Frame_FrameLayerSchema)` to create a new message.
 */
export const Frame_FrameLayerSchema: GenMessage<Frame_FrameLayer, {jsonType: Frame_FrameLayerJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 2, 0);

/**
 * Sprites can have named layers, and these layers can be nested.
 *
 * @generated from message protosprite.Layer
 */
export type Layer = Message<"protosprite.Layer"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool is_group = 2;
   */
  isGroup: boolean;

  /**
   * @generated from field: google.protobuf.Int32Value parent_index = 3;
   */
  parentIndex?: number;

  /**
   * @generated from field: google.protobuf.FloatValue opacity = 4;
   */
  opacity?: number;
};

/**
 * Sprites can have named layers, and these layers can be nested.
 *
 * @generated from message protosprite.Layer
 */
export type LayerJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: bool is_group = 2;
   */
  isGroup?: boolean;

  /**
   * @generated from field: google.protobuf.Int32Value parent_index = 3;
   */
  parentIndex?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.FloatValue opacity = 4;
   */
  opacity?: FloatValueJson;
};

/**
 * Describes the message protosprite.Layer.
 * Use `create(LayerSchema)` to create a new message.
 */
export const LayerSchema: GenMessage<Layer, {jsonType: LayerJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 3);

/**
 * Sprites can have any number of overlapping animations.
 *
 * @generated from message protosprite.Animation
 */
export type Animation = Message<"protosprite.Animation"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 index_start = 2;
   */
  indexStart: number;

  /**
   * @generated from field: int32 index_end = 3;
   */
  indexEnd: number;
};

/**
 * Sprites can have any number of overlapping animations.
 *
 * @generated from message protosprite.Animation
 */
export type AnimationJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: int32 index_start = 2;
   */
  indexStart?: number;

  /**
   * @generated from field: int32 index_end = 3;
   */
  indexEnd?: number;
};

/**
 * Describes the message protosprite.Animation.
 * Use `create(AnimationSchema)` to create a new message.
 */
export const AnimationSchema: GenMessage<Animation, {jsonType: AnimationJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 4);

/**
 * Sprites can embed their sprite sheets.
 *
 * @generated from message protosprite.EmbeddedSpriteSheet
 */
export type EmbeddedSpriteSheet = Message<"protosprite.EmbeddedSpriteSheet"> & {
  /**
   * @generated from field: protosprite.EmbeddedSpriteSheet.Encoding encoding = 1;
   */
  encoding: EmbeddedSpriteSheet_Encoding;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Sprites can embed their sprite sheets.
 *
 * @generated from message protosprite.EmbeddedSpriteSheet
 */
export type EmbeddedSpriteSheetJson = {
  /**
   * @generated from field: protosprite.EmbeddedSpriteSheet.Encoding encoding = 1;
   */
  encoding?: EmbeddedSpriteSheet_EncodingJson;

  /**
   * @generated from field: bytes data = 2;
   */
  data?: string;
};

/**
 * Describes the message protosprite.EmbeddedSpriteSheet.
 * Use `create(EmbeddedSpriteSheetSchema)` to create a new message.
 */
export const EmbeddedSpriteSheetSchema: GenMessage<EmbeddedSpriteSheet, {jsonType: EmbeddedSpriteSheetJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 5);

/**
 * @generated from enum protosprite.EmbeddedSpriteSheet.Encoding
 */
export enum EmbeddedSpriteSheet_Encoding {
  /**
   * @generated from enum value: ENCODING_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ENCODING_PNG = 1;
   */
  PNG = 1,
}

/**
 * @generated from enum protosprite.EmbeddedSpriteSheet.Encoding
 */
export type EmbeddedSpriteSheet_EncodingJson = "ENCODING_UNKNOWN" | "ENCODING_PNG";

/**
 * Describes the enum protosprite.EmbeddedSpriteSheet.Encoding.
 */
export const EmbeddedSpriteSheet_EncodingSchema: GenEnum<EmbeddedSpriteSheet_Encoding, EmbeddedSpriteSheet_EncodingJson> = /*@__PURE__*/
  enumDesc(file_sprite, 5, 0);

/**
 * Sprites can reference external sprite sheets.
 *
 * @generated from message protosprite.ExternalSpriteSheet
 */
export type ExternalSpriteSheet = Message<"protosprite.ExternalSpriteSheet"> & {
  /**
   * @generated from oneof protosprite.ExternalSpriteSheet.source
   */
  source: {
    /**
     * @generated from field: string url = 2;
     */
    value: string;
    case: "url";
  } | {
    /**
     * @generated from field: string file_name = 3;
     */
    value: string;
    case: "fileName";
  } | { case: undefined; value?: undefined };
};

/**
 * Sprites can reference external sprite sheets.
 *
 * @generated from message protosprite.ExternalSpriteSheet
 */
export type ExternalSpriteSheetJson = {
  /**
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName?: string;
};

/**
 * Describes the message protosprite.ExternalSpriteSheet.
 * Use `create(ExternalSpriteSheetSchema)` to create a new message.
 */
export const ExternalSpriteSheetSchema: GenMessage<ExternalSpriteSheet, {jsonType: ExternalSpriteSheetJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 6);

/**
 * Sprite message.
 *
 * @generated from message protosprite.Sprite
 */
export type Sprite = Message<"protosprite.Sprite"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from oneof protosprite.Sprite.pixel_source
   */
  pixelSource: {
    /**
     * @generated from field: bool embedded_in_parent_sheet = 2;
     */
    value: boolean;
    case: "embeddedInParentSheet";
  } | {
    /**
     * @generated from field: protosprite.EmbeddedSpriteSheet embedded_sheet = 3;
     */
    value: EmbeddedSpriteSheet;
    case: "embeddedSheet";
  } | {
    /**
     * @generated from field: protosprite.ExternalSpriteSheet external_sheet = 4;
     */
    value: ExternalSpriteSheet;
    case: "externalSheet";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated protosprite.Frame frames = 5;
   */
  frames: Frame[];

  /**
   * @generated from field: repeated protosprite.Layer layers = 6;
   */
  layers: Layer[];

  /**
   * @generated from field: repeated protosprite.Animation animations = 7;
   */
  animations: Animation[];

  /**
   * @generated from field: protosprite.Size size = 8;
   */
  size?: Size;
};

/**
 * Sprite message.
 *
 * @generated from message protosprite.Sprite
 */
export type SpriteJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: bool embedded_in_parent_sheet = 2;
   */
  embeddedInParentSheet?: boolean;

  /**
   * @generated from field: protosprite.EmbeddedSpriteSheet embedded_sheet = 3;
   */
  embeddedSheet?: EmbeddedSpriteSheetJson;

  /**
   * @generated from field: protosprite.ExternalSpriteSheet external_sheet = 4;
   */
  externalSheet?: ExternalSpriteSheetJson;

  /**
   * @generated from field: repeated protosprite.Frame frames = 5;
   */
  frames?: FrameJson[];

  /**
   * @generated from field: repeated protosprite.Layer layers = 6;
   */
  layers?: LayerJson[];

  /**
   * @generated from field: repeated protosprite.Animation animations = 7;
   */
  animations?: AnimationJson[];

  /**
   * @generated from field: protosprite.Size size = 8;
   */
  size?: SizeJson;
};

/**
 * Describes the message protosprite.Sprite.
 * Use `create(SpriteSchema)` to create a new message.
 */
export const SpriteSchema: GenMessage<Sprite, {jsonType: SpriteJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 7);

/**
 * Sprite sheet message.
 *
 * @generated from message protosprite.SpriteSheet
 */
export type SpriteSheet = Message<"protosprite.SpriteSheet"> & {
  /**
   * @generated from field: repeated protosprite.Sprite sprites = 1;
   */
  sprites: Sprite[];

  /**
   * @generated from oneof protosprite.SpriteSheet.pixel_source
   */
  pixelSource: {
    /**
     * @generated from field: protosprite.EmbeddedSpriteSheet embedded_sheet = 2;
     */
    value: EmbeddedSpriteSheet;
    case: "embeddedSheet";
  } | {
    /**
     * @generated from field: protosprite.ExternalSpriteSheet external_sheet = 3;
     */
    value: ExternalSpriteSheet;
    case: "externalSheet";
  } | { case: undefined; value?: undefined };
};

/**
 * Sprite sheet message.
 *
 * @generated from message protosprite.SpriteSheet
 */
export type SpriteSheetJson = {
  /**
   * @generated from field: repeated protosprite.Sprite sprites = 1;
   */
  sprites?: SpriteJson[];

  /**
   * @generated from field: protosprite.EmbeddedSpriteSheet embedded_sheet = 2;
   */
  embeddedSheet?: EmbeddedSpriteSheetJson;

  /**
   * @generated from field: protosprite.ExternalSpriteSheet external_sheet = 3;
   */
  externalSheet?: ExternalSpriteSheetJson;
};

/**
 * Describes the message protosprite.SpriteSheet.
 * Use `create(SpriteSheetSchema)` to create a new message.
 */
export const SpriteSheetSchema: GenMessage<SpriteSheet, {jsonType: SpriteSheetJson}> = /*@__PURE__*/
  messageDesc(file_sprite, 8);

